'use strict';

module.exports = require('../../functions/makeLang')({
	ERROR: 'Invalid username!',
	MIN_LENGTH: 'Your minecraft username is too short!',
	MAX_LENGTH: 'Your minecraft username is too long!'
});
